module.exports = __webpack_public_path__ + "img/wban-logo-fantom.dcbe0a28.svg";